import React from 'react';
import { Edit3, Trash2, Globe } from 'lucide-react';
import { StarRating } from '@/components/StarRating';

export default function TestimonialCard({ testimonial: t, onEdit, onDelete }) {
  return (
    <div className={`bg-white rounded-lg border shadow-card-lift p-4 ${t.published ? 'border-saffron-100/50' : 'border-earth/10 opacity-60'}`} data-testid={`testimonial-${t.id}`}>
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-display text-sm font-bold text-earth-dark">{t.name}</span>
            <span className="text-[10px] text-earth/40 font-sans">•</span>
            <span className="text-xs text-earth/50 font-sans">{t.company}</span>
            {!t.published && <span className="text-[9px] uppercase tracking-wider bg-earth/10 text-earth/50 px-2 py-0.5 rounded font-sans font-semibold">Draft</span>}
          </div>
          <div className="flex items-center gap-1 mb-2">
            <Globe size={10} className="text-saffron/50" />
            <span className="text-[10px] text-earth/40 font-sans">{t.country}</span>
            <span className="text-earth/20 mx-1">•</span>
            <StarRating rating={t.rating} size={10} />
          </div>
          <p className="text-sm text-earth/70 font-sans leading-relaxed">"{t.text}"</p>
        </div>
        <div className="flex gap-1 ml-3 flex-shrink-0">
          <button onClick={() => onEdit(t)} className="p-1.5 hover:bg-cream rounded-md transition-colors" data-testid={`edit-testimonial-${t.id}`}>
            <Edit3 size={13} className="text-earth/40" />
          </button>
          <button onClick={() => onDelete(t.id)} className="p-1.5 hover:bg-red-50 rounded-md transition-colors" data-testid={`delete-testimonial-${t.id}`}>
            <Trash2 size={13} className="text-red-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
